import React, { useState } from 'react';
import Dialog from '@mui/material/Dialog';
import DialogTitle from '@mui/material/DialogTitle';
import DialogContent from '@mui/material/DialogContent';
import DialogActions from '@mui/material/DialogActions';
import FormControl from '@mui/material/FormControl';
import InputLabel from '@mui/material/InputLabel';
import Select from '@mui/material/Select';
import MenuItem from '@mui/material/MenuItem';
import TextField from '@mui/material/TextField';
import Button from '@mui/material/Button';
import Typography from '@material-ui/core/Typography';
import InputAdornment from '@material-ui/core/InputAdornment';
import SearchIcon from '@material-ui/icons/Search';
import { Grid } from '@mui/material';
import { Map, Marker, TileLayer, Popup } from 'react-leaflet';
import Leaflet from 'leaflet';
import greenMarker from '../../../../assets/images/Marker/greenMarker.png';
import redMarker from '../../../../assets/images/Marker/redMarker.png';
import blueMarker from '../../../../assets/images/Marker/blueMarker.png';
import LocationMark from '../../../../assets/images/Marker/Location Mark.F02.2k.png';
import LocationGreen from '../../../../assets/images/Marker/Location Sign Green.F10.2k.png';

const iconIn = Leaflet.icon({
    // iconUrl: greenMarker,
    iconUrl: LocationGreen,
    iconSize: [80, 80], // Defina o tamanho desejado aqui, por exemplo, 32x32 pixels
    iconAnchor: [15, 41],
    popupAnchor: [0, -41]
});

const iconOut = Leaflet.icon({
    // iconUrl: redMarker,
    iconUrl: LocationMark,
    iconSize: [80, 80], // Defina o tamanho desejado aqui, por exemplo, 32x32 pixels
    iconAnchor: [15, 41],
    popupAnchor: [0, -41], // point from which the popup should open relative to the iconAnchor
});
const iconAllowed = Leaflet.icon({
    iconUrl: blueMarker,
    iconAnchor: [13.5, 41],
    popupAnchor: [0, -41], // point from which the popup should open relative to the iconAnchor
});

const ViewLocation = ({ handleCloseViewLocation, row, locationAProved,evetnMap }) => {
    const lat = row && row.adressLocation && row.adressLocation.lat !== undefined ? row.adressLocation.lat : '-19.912998';
    const lng = row && row.adressLocation && row.adressLocation.lng !== undefined ? row.adressLocation.lng : '-43.940933';
    const zoom = row && row.adressLocation && row.adressLocation.lng !== undefined ? 17 : 1;
    const type = row && row.type == "Saída" ? "Saída" : "Entrada"
    return (
        <>
            {/* <Dialog
                open={open}
                onClose={onClose}
            > */}
            <DialogTitle style={{ textAlign: 'center', width: 500, justifyContent: 'center', marginLeft: '15px' }}>LOCALIZAÇÃO DO PONTO</DialogTitle>
            <Map
                center={[lat, lng]}
                zoomControl={false}
                zoom={zoom}
                style={{ height: '60%', margin: '0 auto', width: '90%', alignItems: 'center', borderRadius: '20px' }}
            >
                <TileLayer
                    // attribution="&copy; <a href=&quot;http://osm.org/copyright&quot;>OpenStreetMap</a> contributors"
                    url="https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png"
                />
                <Marker
                    position={[lat, lng]}
                    icon={type == "Saída" ? iconOut : iconIn}
                    popupAnchor={[0, -41]}
                ></Marker>
            </Map>
            <DialogActions style={{ justifyContent: 'center', display: 'flex', marginTop: '30px' }}>
                {
                    locationAProved ?

                        (
                            <>
                                <Button
                                    onClick={() => evetnMap("REJEITADO")}
                                    variant="contained" style={{ backgroundColor: '#e01b38', color: 'white', borderRadius: '20px', height: '50px', width: '30%' }}>
                                    Rejeitar
                                </Button>
                                <Button
                                    variant="contained"
                                    style={{
                                        backgroundColor: '#51ad60',
                                        color: 'white',
                                        borderRadius: '20px',
                                        height: '50px',
                                        width: '30%',
                                        border: '1px solid #4851de'
                                    }}
                                    onClick={() => evetnMap("APROVADO")}
                                >
                                    Aprovar
                                </Button>
                            </>
                        )
                        :
                        (

                            <Button
                                variant="contained"
                                style={{
                                    backgroundColor: 'white',
                                    color: '#4851de',
                                    borderRadius: '20px',
                                    height: '50px',
                                    width: '30%',
                                    border: '1px solid #4851de'
                                }}
                                onClick={handleCloseViewLocation}
                            >
                                Voltar
                            </Button>
                        )
                }
            </DialogActions>
            {/* </Dialog> */}
        </>
    )
}

export default ViewLocation;